import Model from './Model'
import Avatar from './Avatar'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class User extends Model {
  resource() {
    return 'users'
  }

  avatar() {
    return this.hasMany(Avatar)
  }

  get avatarText() {
    return this.first_name.charAt(0) + this.last_name.charAt(0)
  }

  get status() {
    return this.active ? 'Active' : 'Blocked'
  }

  get statusColor() {
    return this.active ? 'primary' : 'red'
  }

  get ids() {
    return this.photo_id ? this.photo_id : null
  }

  get idStatus() {
    if (this.isIdVerified) return 'Verified'
    if (this.isIdDeclined) return 'Declined'
    if (this.isIdPending) return 'Pending approval'
    return 'Awaiting IDs'
  }

  get idStatusColor() {
    if (this.isIdVerified) return 'primary'
    if (this.isIdDeclined) return 'red'
    if (this.isIdPending) return 'warning'
    return 'warning'
  }

  get idFront() {
    return this.ids ? this.ids.front : null
  }

  get idHeadshot() {
    return this.ids ? this.ids.headshot : null
  }

  get isIdVerified() {
    return this.ids && this.ids.verified
  }

  get isIdDeclined() {
    return this.ids && this.ids.declined
  }

  get isIdPending() {
    return (
      !this.isIdVerified &&
      !this.isIdDeclined &&
      this.idFront &&
      this.idHeadshot
    )
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
